import { SVGProps } from "react";

export function MenuBarIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="menu-bar" 
             xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="M4 18q-.425 0-.712-.288T3 17t.288-.712T4 16h16q.425 0 .713.288T21 17t-.288.713T20 18zm0-5q-.425 0-.712-.288T3 12t.288-.712T4 11h16q.425 0 .713.288T21 12t-.288.713T20 13zm0-5q-.425 0-.712-.288T3 7t.288-.712T4 6h16q.425 0 .713.288T21 7t-.288.713T20 8z">
            </path>
        </svg>
    );
}

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="close" 
             xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z">
            </path>
        </svg>
    );
}

export function LanguageIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="language-change-icon"
             xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <g fill="none" stroke="currentColor" strokeLinecap="round" 
               strokeLinejoin="round" strokeWidth={2}>
                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0m.6-3h16.8M3.6 15h16.8"></path>
                <path d="M11.5 3a17 17 0 0 0 0 18m1-18a17 17 0 0 1 0 18"></path>
            </g>
        </svg>
    );
}

export function CloseLanguageIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="close-language-button"
             xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="M12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8">
            </path>
        </svg>
    );
}


export function WhatsappIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="whatsapp-icon" 
             xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" 
                  d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28">
            </path>
        </svg>
    );
}


export function ChatIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="chat-icon"
             xmlns="http://www.w3.org/2000/svg" 
             width={24}
             height={24}
             viewBox="0 0 16 16" {...props}>
            <path d="M0 0h16v16H0z" fill="none" />
            <g fill="currentColor">
                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                <path d="M5 6a1 1 0 1 1-2 0a1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0" />
            </g>
        </svg>
    );
}


export function InstagramIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="instagram-icon"
             xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" 
                  d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3">
            </path>
        </svg>
    );
}

export function CaretIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="caret-icon"
             xmlns="http://www.w3.org/2000/svg" 
             width={36} 
             height={36} 
             viewBox="0 0 36 36" {...props}>
            <path fill="currentColor" 
                  d="M29.52 22.52L18 10.6L6.48 22.52a1.7 1.7 0 0 0 2.45 2.36L18 15.49l9.08 9.39a1.7 1.7 0 0 0 2.45-2.36Z" className="clr-i-outline clr-i-outline-path-1">
            </path>
            <path fill="none" 
                  d="M0 0h36v36H0z">
            </path>
        </svg>
    );
}

/* ================== */
/* --- Room Icons --- */
/* ================== */

export function BedIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="M2 19v-6q0-.675.275-1.225T3 10.8V8q0-1.25.875-2.125T6 5h4q.575 0 1.075.213T12 5.8q.425-.375.925-.587T14 5h4q1.25 0 2.125.875T21 8v2.8q.45.425.725.975T22 13v6h-2v-2H4v2zm11-9h6V8q0-.425-.288-.712T18 7h-4q-.425 0-.712.288T13 8zm-8 0h6V8q0-.425-.288-.712T10 7H6q-.425 0-.712.288T5 8zm-1 5h16v-2q0-.425-.288-.712T19 12H5q-.425 0-.712.288T4 13zm16 0H4z">
            </path>
        </svg>
    );
}

export function SizeIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24"
             {...props}>
            <path fill="none" 
                  stroke="currentColor" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M3 5h11m-2 2l2-2l-2-2M5 3L3 5l2 2m14 3v11m-2-2l2 2l2-2m0-7l-2-2l-2 2M3 12a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z">
            </path>
        </svg>
    );
}

export function WiFiIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="M12 21q-1.05 0-1.775-.725T9.5 18.5t.725-1.775T12 16t1.775.725t.725 1.775t-.725 1.775T12 21m-5.65-5.65l-2.1-2.15q1.475-1.475 3.463-2.337T12 10t4.288.875t3.462 2.375l-2.1 2.1q-1.1-1.1-2.55-1.725T12 13t-3.1.625t-2.55 1.725M2.1 11.1L0 9q2.3-2.35 5.375-3.675T12 4t6.625 1.325T24 9l-2.1 2.1q-1.925-1.925-4.462-3.012T12 7T6.563 8.088T2.1 11.1">
            </path>
        </svg>
    );
}

export function SafeBoxIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="M4 4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2v1h2v-1h11v1h2v-1a2 2 0 0 0 2-2v-1h1v-2h-1V9h1V7h-1V6a2 2 0 0 0-2-2zm0 2h15v11H4zm9.5 1.5a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4M5 9v5h2V9zm8.5.5a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2">
            </path>
        </svg>
    );
}

export function MountainIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg aria-label="mountain-icon" 
             xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="M23 18H1l7.25-9.67l2 2.67L14 6zm-11.5-5.33L14 16h5l-5-6.67zM5 16h6.5l-3.25-4.33z">
            </path>
        </svg>
    );
}

export function CityIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" 
                  d="M19 15h-2v-2h2m0 6h-2v-2h2M13 7h-2V5h2m0 6h-2V9h2m0 6h-2v-2h2m0 6h-2v-2h2m-6-6H5V9h2m0 6H5v-2h2m0 6H5v-2h2m8-6V5l-3-3l-3 3v2H3v14h18V11z">
            </path>
        </svg>
    );
}

export function LakeIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="M20 12h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33m0-6h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2V6h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0C17.22 5.53 18.61 6 20 6m0 12h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33">
            </path>
        </svg>
    );
}

export function WashingMachineIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" {...props}>
            <g fill="none">
                <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path><path fill="currentColor" d="M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm1 8H6v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zm-6 1a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4m5-9H7a1 1 0 0 0-.993.883L6 5v3h12V5a1 1 0 0 0-1-1m-1 1a1 1 0 0 1 .117 1.993L16 7h-1a1 1 0 0 1-.117-1.993L15 5zm-4 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2">
                </path>
            </g>
        </svg>
    );
}

export function ShowerIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" 
                  d="M8 18q-.425 0-.712-.288T7 17t.288-.712T8 16t.713.288T9 17t-.288.713T8 18m4 0q-.425 0-.712-.288T11 17t.288-.712T12 16t.713.288T13 17t-.288.713T12 18m4 0q-.425 0-.712-.288T15 17t.288-.712T16 16t.713.288T17 17t-.288.713T16 18M5 14v-2q0-2.65 1.7-4.6T11 5.1V3h2v2.1q2.6.35 4.3 2.3T19 12v2zm3 7q-.425 0-.712-.288T7 20t.288-.712T8 19t.713.288T9 20t-.288.713T8 21m4 0q-.425 0-.712-.288T11 20t.288-.712T12 19t.713.288T13 20t-.288.713T12 21m4 0q-.425 0-.712-.288T15 20t.288-.712T16 19t.713.288T17 20t-.288.713T16 21">
            </path>
        </svg>
    );
}

export function KitchenIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" 
                  fillRule="evenodd" 
                  d="m7.588 20.026l-3.57-3.49C2.674 15.222 2 14.564 2 13.747c0-.537.29-1.005.87-1.635c.59-.643.886-.964 1.02-1.3c.133-.336.137-.714.144-1.47L4.066 6c-.034-2.183 1.375-3.973 3.147-4c1.455-.022 2.702 1.152 3.121 2.78l.466-.456c2.562-2.505 6.716-2.505 9.278 0a6.314 6.314 0 0 1 0 9.072l-6.78 6.63C11.952 21.342 11.278 22 10.443 22c-.837 0-1.51-.658-2.855-1.974M5.98 12.872a.75.75 0 0 1 1.06-.012l4.283 4.187a.75.75 0 0 1-1.048 1.073l-4.283-4.187a.75.75 0 0 1-.012-1.06" 
                  clipRule="evenodd">
            </path>
        </svg>
    );
}

export function WindowShutterIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" 
                  d="M3 4h18v4h-2v12h-2V8H7v12H5V8H3zm5 5h8v2H8zm0 3h8v2H8zm0 3h8v2H8zm0 3h8v2H8z">
            </path>
        </svg>
    );
}


export function RoomQuantityIcon(props: SVGProps<SVGSVGElement>) {
	return (
        <svg xmlns="http://www.w3.org/2000/svg" 
             width={24} 
             height={24} 
             viewBox="0 0 24 24" 
             {...props}>
            <path fill="currentColor" 
                  d="M4 21q-.425 0-.712-.288T3 20t.288-.712T4 19h1V4q0-.425.288-.712T6 3h7q.425 0 .713.288T14 4h4q.425 0 .713.288T19 5v14h1q.425 0 .713.288T21 20t-.288.713T20 21h-2q-.425 0-.712-.288T17 20V6h-3v14q0 .425-.288.713T13 21zm8-9q0-.425-.288-.712T11 11t-.712.288T10 12t.288.713T11 13t.713-.288T12 12">
            </path>
        </svg>
    );
}
